import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate,useParams, MESSAGES } from './../../common/helper/common-imports.component.js'; 
import {fieldValidation  } from '../../common/helper/form-constants.js';
import {AgentsService,ConfigService} from "../../../services/index.js";

import { FormField, SelectField } from './../../common/helper/formFields';

const ApproveAgent = () => {
    const { id,cust_id } = useParams();
    const [agent, setAgent] = useState({});
    const [limitGroup, setLimit] = useState([]);
    const [commGroup, setCommGroup] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const gender = [{
        label : 'Male',
        value : 'M'
    },
    {
        label : 'Female',
        value : 'F'
    }
]
const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        gender: '',
        phoneNumber: '',
        nationalID: '',
        datofBirth: '',
        comm_grp_id: '',
        limit_group_id: ''

    })

    const [errors, setErrors] = useState({
        fullName: '',
        email: '',
        gender: '',
        phoneNumber: '',
        nationalID: '',
        datofBirth: '',
        agentID: '',
        comm_grp_id: '',
        limit_group_id: ''
    })

    const fetchData = async (customerId) => {
      try {
        setLoading(true);
        const [commResponse, limitResponse] = await Promise.all([
          ConfigService.getCommGroups('AGENT',customerId),
          ConfigService.getLimitGroups(),
       
        ]);

        const limit =  limitResponse.data.data.map(record => ({ value: record.key, label: record.value, is_default: record.is_default }));
        const comm =   commResponse.data.data.map(record => ({ value: record.key, label: record.value, is_default: record.is_default }));
        const defaultLimit = limit.find(item => item.is_default);
        const defaultCommsion = comm.find(item => item.is_default);
        
        setCommGroup(comm);
        setLimit(limit)
       // getAgent();
        console.log(defaultLimit)
        setTimeout(() => {
          setFormData(prevFormData => ({
            ...prevFormData,
            limit_group_id: defaultLimit.is_default ? defaultLimit.value : '',
            comm_grp_id: defaultCommsion.is_default ? defaultCommsion.value : ''
          }));
        
        }, 1000);
   
        setLoading(false);
      } catch (error) {
        setLoading(false);
  
      }
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
        validateField(name, value);
      };
    
      
  const validateField = (fieldName, value) => {
    const errorMessage = fieldValidation(fieldName, value);
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
    return errorMessage;
  };

  const approveAgent = (e, approvalStatus ='A') => {
    e.preventDefault();
    console.log(formData)
    let hasErrors = false;
        let requiredFields =['fullName', 'email', 'phoneNumber', 'datofBirth','gender', 'limit_group_id', 'comm_grp_id'];
        requiredFields.forEach(fieldName => {
          const error = validateField(fieldName, formData[fieldName]);
          if (error) {
            hasErrors = true;
          }
        });
    if(!hasErrors){
        setLoading(true);
        const inputDate = formData.datofBirth; 
        const parts = inputDate.split('-');
        const formattedDateOfBirth = `${parts[2]}-${parts[1]}-${parts[0]}`;
        const data = {
            "full_name": formData.fullName,
            "user_id": agent.user_id,
            "email_address": formData.email,
            "mobile_number": formData.phoneNumber,
            "date_of_birth": formattedDateOfBirth,
            "gender_id": formData.gender,
            "national_id": formData.nationalID,
            "approval_status": approvalStatus,
            "comm_grp_id":formData.comm_grp_id,
            "limit_group_id":formData.limit_group_id,
            

            }
        AgentsService.approveAgentAction(data)
          .then(response => {
            setLoading(false);
            navigate('/agents')
            if(approvalStatus == 'R') {
              toast.success(MESSAGES.AGENT_REJECTED)

            } else {
              toast.success(MESSAGES.AGENT_APPROVED)

            }
          })
          .catch(error => {
            setLoading(false);
            try {
              const errorMessage = error.response.data
              toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
            } catch (e){
              toast.error( MESSAGES.SERVER_ERROR)
            }
          });
    }
    
  }
  
  const reject = (e) => {
    const approvalStatus = 'R'
    approveAgent(e,approvalStatus)
  }
  const getAgent = () => {
    setLoading(true);
    AgentsService.getAgentDetails(id)
          .then(response => {
            const data =response.data.data
            setAgent(data)
            const inputDate = data.date_of_birth; 
            const parts = inputDate.split('-');
            const formattedDateOfBirth = `${parts[2]}-${parts[1]}-${parts[0]}`;
            const agentResponse = {
                "fullName": data.full_name,
                "email": data.email_address,
                "phoneNumber": data.mobile_number,
                "datofBirth": formattedDateOfBirth,
                "gender": data.gender_id,
                "nationalID": data.national_id || '',
                "comm_grp_id": data.comm_grp_id,
                "limit_group_id": data.limit_group_id

                }
                fetchData(data.customer_id)
            setFormData(agentResponse)
            setLoading(false);
          })
          .catch(error => {
            setLoading(false);
          });
  }
    useEffect(() => {
        getAgent();
        document.body.style.backgroundImage = '';

        document.body.style.backgroundColor = '#f0f6fa';
        return () => {
          document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
        };
}, []);
    return (
        <div>
        <LoaderOverlay loading={loading} />
        <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
          <h4 className="updatename" style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>Approve Agent</h4>
          <div className="container" style={{backgroundColor: 'white'}}>
            <nav>
              <div className="nav nav-tabs" id="nav-tab" role="tablist">
                <button className="nav-link active tbbtn" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">Agent Details</button>
              </div>
            </nav>
            <div className="tab-content" id="nav-tabContent" style={{paddingTop: '15px'}}>
              <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                <div className="panel panel-default">
                <form method="post" id="approve_form" name="approve_form" action="#" onSubmit={approveAgent}>
                  <div className="panel-body" style={{padding: '0px'}}>
                    <div className="col-md-12" style={{padding: 0}}>
                      <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                        
                        <div className="form-group frm" style={{textAlign: 'left'}}>
                          {/* <label htmlFor="f_name">AGENT ID</label>
                          <input type="text" className="form-control" id="first_name" defaultValue={2222252524} name="f_name" disabled /> */}
                          <FormField
                           type="text"
                           isRequierd = {false}
                           id="agentID"
                           name="agentID"
                           label="AGENT ID"
                           placeholder = "Enter Agent ID"
                          
                           disabled={true.toString()}
                           value={agent.agent_id}
                           maxlength={20}
                        />
                        </div>
                        <div className="form-group frm" style={{textAlign: 'left'}}>
                          {/* <label className="required" htmlFor="f_name">FULL NAME</label>
                          <input type="text" className="form-control" id="profilef_name" placeholder="Enter Your Full Name" name="profilef_name" />
                          <span id="error_profile_fname" className="text-danger" /> */}
                           <FormField
                           type="text"
                           isRequierd = {true}
                           id="f_name"
                           name="fullName"
                           label="FULL NAME"
                           placeholder = "Enter Full Name"
                           value={formData.fullName}
                           onChange={handleChange}
                           error={errors.fullName}
                           
                           
                        />
                        </div>
                        <div className="form-group frm" style={{textAlign: 'left'}}>
                          {/* <label className="required" htmlFor="f_name">EMAIL</label>
                          <input type="email" className="form-control" id="profiles_email" placeholder="Enter Your Email Address" name="profiles_email" />
                          <span id="error_profiles_email" className="text-danger" /> */}
                           <FormField
                           type="text"
                           isRequierd = {true}
                           id="email"
                           name="email"
                           label="EMAIL"
                           placeholder = "Enter email"
                           value={formData.email}
                           onChange={handleChange}
                           error={errors.email}
                        />
                        </div>
                        <div className="form-group frm" style={{textAlign: 'left'}}>
                          
                              <SelectField 
                                id="gender"
                                isRequierd = {true}
                                name="gender"
                                label="GENDER"
                                selectedField = "Select Gender"
                                value={formData.gender}
                                onChange={handleChange}
                                error={errors.gender}
                                options={gender}
                                />
                          
                          <span id="error_profiles_gender" className="text-danger" />
                        </div>
                        <div className="form-group frm" style={{textAlign: 'left'}}>
                          
                          <SelectField 
                            id="limit_group_id"
                            isRequierd = {true}
                            name="limit_group_id"
                            label="LIMIT GROUP"
                            selectedField = "Select Limit Group"
                            value={formData.limit_group_id}
                            onChange={handleChange}
                            error={errors.limit_group_id}
                            options={limitGroup}
                            />
                      
                      <span id="error_profiles_gender" className="text-danger" />
                    </div>
                      </div>
                      <div className="col-md-4" style={{padding: '0px', paddingRight: '30px'}}>
                        <div className="form-group frm" style={{textAlign: 'left'}}>
                          {/* <label htmlFor="f_name">NATIONAL ID</label>
                          <input type="text" className="form-control" id="first_name" defaultValue="IND123" name="f_name" /> */}
                           <FormField
                           type="text"
                           isRequierd = {false}
                           id="nationalID"
                           name="nationalID"
                           label="NATIONAL ID"
                           placeholder = "Enter National ID"
                           value={formData.nationalID}
                           onChange={handleChange}
                        
                        />
                        </div>
                        <div className="form-group frm" style={{textAlign: 'left'}}>
                          {/* <label className="required" htmlFor="f_name">DATE OF BIRTH</label>
                          <input type="date" className="form-control" id="profiles_dob" name="profiles_dob" />
                          <span id="error_profiles_dob" className="text-danger" /> */}
                          <FormField
                           type="date"
                           isRequierd = {true}
                           id="datofBirth"
                           name="datofBirth"
                           label="DATE OF BIRTH"
                           placeholder = "Enter DOB"
                           value={formData.datofBirth}
                           onChange={handleChange}
                           error={errors.datofBirth}
                        />
                        </div>
                        <div className="form-group frm" style={{textAlign: 'left'}}>
                          {/* <label className="required" htmlFor="f_name">PHONE NUMBER</label>
                          <input type="number" className="form-control" id="profiles_phone" placeholder="Enter Your Phone Number" name="profiles_phone" />
                          <span id="error_profiles_phone" className="text-danger" /> */}
                          <FormField
                           type="text"
                           isRequierd = {true}
                           id="phoneNumber"
                           name="phoneNumber"
                           label="PHONE NUMBER"
                           placeholder = "Enter Phone Number"
                           value={formData.phoneNumber}
                           onChange={handleChange}
                           error={errors.phoneNumber}
                        />
                        </div>
                        <div className="form-group frm" style={{textAlign: 'left'}}>
                          {/* <label className="required" htmlFor="f_name">PHONE NUMBER</label>
                          <input type="number" className="form-control" id="profiles_phone" placeholder="Enter Your Phone Number" name="profiles_phone" />
                          <span id="error_profiles_phone" className="text-danger" /> */}
                          <FormField
                           type="text"
                           isRequierd = {false}
                           id="remarks"
                           name="remarks"
                           label="Remarks"
                           placeholder = "Remarks"
                           value={formData.remarks}
                           onChange={handleChange}
                           error={errors.remarks}
                        />
                        </div>
                        <div className="form-group frm" style={{textAlign: 'left'}}>
                          
                          <SelectField 
                            id="comm_grp_id"
                            isRequierd = {true}
                            name="comm_grp_id"
                            label="COMMISSION GROUP"
                            selectedField = "Select Commssion Group"
                            value={formData.comm_grp_id}
                            onChange={handleChange}
                            error={errors.comm_grp_id}
                            options={commGroup}
                            />
                      
                      <span id="error_profiles_gender" className="text-danger" />
                    </div>
                      </div>
                    </div>
                    <br />
                    <div align="left">
                      <button type="button" onClick={reject} name="btn_admin_details" id="btn_basics_details_reject" className="btn ddfgg sebtn">Reject</button>
                      <button type="submit"  name="btn_admin_details" id="btn_basics_details_approve" className="btn ddfg sebtn">Approve</button>
                    </div>
                    <br />
                  </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      );
} 


export default withAuth(ApproveAgent);